'use client';
import { jsx } from '@emotion/react/jsx-runtime';
import { forwardRef } from 'react';
import { NewSlimChatLinear } from '@s7/icons';
import { composeHandlers } from '@s7/react-utils';
import { packSX } from '@s7/styles';
import { Button } from '@s7/ui';
import { useAnalytics } from '../../analytics.js';
import { useShadowStyle } from '../../hooks/useShadowStyle/useShadowStyle.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const chatButtonStyles = (theme)=>({
        padding: theme.fn.space('3.5s'),
        borderRadius: theme.fn.borderRadius('1.5r')
    });
const HeaderChat = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { sx, onClick } = props, others = _object_without_properties_loose(props, [
        "sx",
        "onClick"
    ]);
    const shadowStyle = useShadowStyle();
    const headerTopic = useAnalytics('header');
    return /*#__PURE__*/ jsx(Button, _extends({
        ref: ref,
        "aria-label": "chat",
        leftSide: /*#__PURE__*/ jsx(NewSlimChatLinear, {
            color: "text.primary",
            size: 20
        }),
        sx: [
            chatButtonStyles,
            shadowStyle,
            ...packSX(sx)
        ],
        variant: "white",
        onClick: composeHandlers(onClick, headerTopic.goChat)
    }, others));
});

export { HeaderChat };
//# sourceMappingURL=HeaderChat.js.map
